module.exports = __webpack_public_path__ + "static/media/Sort Z-a-blue.d4979570.svg";